import { HttpClient } from "@angular/common/http";
import { map, catchError } from "rxjs";
import { httpOptionsDefault } from "../../_shared/constants";
import { WebApiService } from "../WebApiService";



export class CryptoController {

  constructor(public _http: HttpClient, private _webApi: WebApiService) {
  }
  decrypt(text: string): Promise<string> {

    console.log(this._webApi.GetApiAddress() + `/crypto/decrypt`);

    return this._http.post(this._webApi.GetApiAddress() + `/crypto/decrypt`, { value: text }, httpOptionsDefault)
      .pipe(
        map(result => {


          return result;
        }

        ),
        catchError(error => {

          return error;
        })
      )
      .toPromise().then((result: any) => {


        return result.value;
      });

  }

  encrypt(text: string): Promise<string> {
    return this._http.get(this._webApi.GetApiAddress() + `/crypto/encrypt/${text}`, httpOptionsDefault)
      .pipe(
        map(result => {


          return result;
        }

        ),
        catchError(error => {

          return error;
        })
      )
      .toPromise().then((result: any) => {


        return result.value;
      });
  }

}
